import { motion, useReducedMotion } from 'framer-motion';
import ExperienceTimeline from './ExperienceTimeline';
import { useConfig } from '../../context/useConfig';
import { fadeInUp, fadeIn } from '../../utils/motionVariants';

const ExperiencePage = () => {
  const { config } = useConfig();
  const reduceMotion = useReducedMotion();

  const heading = config.experienceSection?.heading || config.ui?.experiencePageHeading || 'Professional Journey';

  // No skeleton needed - we start with fallback config for immediate render

  return (
  <section id="experience" aria-labelledby="experience-heading" className="relative isolate py-28 sm:py-32 bg-gradient-to-b from-emerald-50 via-white to-cyan-50 overflow-hidden">
      {/* Ambient gradient blobs (consistent with About styling) */}
  <div aria-hidden className="pointer-events-none hidden sm:block absolute -top-16 -left-20 w-[28rem] h-[28rem] rounded-full bg-emerald-300/40 blur-3xl" />
  <div aria-hidden className="pointer-events-none hidden sm:block absolute bottom-[-18%] -right-24 w-[30rem] h-[30rem] rounded-full bg-cyan-300/40 blur-3xl" />
      <div aria-hidden className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(circle_at_1px_1px,#000_1px,transparent_0)] [background-size:22px_22px]" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative">
        <motion.header
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          className="max-w-3xl mx-auto text-center"
        >
          <motion.h2
            id="experience-heading"
            variants={fadeInUp(0, reduceMotion ? 0 : 24)}
            className="text-4xl sm:text-5xl font-extrabold tracking-tight gradient-text"
          >
            {heading}
          </motion.h2>
          {config.site?.tagline && (
            <motion.p
              variants={fadeIn(0.15)}
              className="mt-6 text-lg text-gray-600 font-medium leading-relaxed"
            >
              {config.site.tagline}
            </motion.p>
          )}
        </motion.header>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeIn(0.2)}
          className="mt-20 max-w-5xl mx-auto"
        >
          <ExperienceTimeline />
        </motion.div>
      </div>
    </section>
  );
};

export default ExperiencePage;
